import { showBase64quote } from '../services/osir.service';
import { generateQuoteDocumentSelector } from '../recoil/selectors/generateQuoteDocumentSelector';
import { useAsyncRecoilValue } from './useAsyncRecoilValue';
import { constSelector, useRecoilValue } from 'recoil';
import { jobAtom } from '../recoil/atoms/jobAtom';
import { QUOTED } from '../recoil/types/types';
import { isLoggedOnSelector } from '../recoil/selectors/isLoggedOnSelector';

export const useDocumentPreview = (): {
    generateQuoteDocument: () => void;
    isDocumentLoading: boolean;
} => {
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);
    const { jobStatus } = useRecoilValue(jobAtom);
    const isJobQuoted = jobStatus === QUOTED;
    const shouldPrefetchDocument = isLoggedOn && isJobQuoted;
    const [document, isDocumentLoading] = useAsyncRecoilValue(
        shouldPrefetchDocument ? generateQuoteDocumentSelector : constSelector(null)
    );
    const generateQuoteDocument = (): void => {
        if (isDocumentLoading || !document) return;
        showBase64quote(document?.base64PDF ?? '');
    };

    return { generateQuoteDocument, isDocumentLoading: isDocumentLoading || !document };
};
